import React, {
    useCallback, useMemo, useRef, useState,
} from 'react';

import Button from '~/components/Button';
import Input from '~/components/Input';
import SimpleListContent from '~/components/ListPageContent/SimpleListContent';
import Modal from '~/components/Modal';
import Table from '~/components/Table';
import { wrapDialog } from '~/helpers/dialog-helper';
import { extractRequestError } from '~/helpers/error-helper';
import useAxios from '~/hooks/use-axios';

import styles from './CompaniesModal.module.scss';

const { Column } = Table;

const CompaniesModal = ({ onChange, onCancel, ...others }) => {
    const api = useAxios();
    const $companiesListRef = useRef(null);
    const [selectedCompany, setSelectedCompany] = useState(null);

    const requestDataSource = useCallback(async (filterValues, orderValues, page, limit) => {
        try {
            const {
                name,
            } = filterValues;

            const response = await api.get('/Company/GetCompanyListingForNewPerson', {
                params: {
                    name,
                    pageIndex: page,
                    pageSize: limit,
                },
            });

            return response;
        } catch (err) {
            extractRequestError(
                err,
                'Não foi possível buscar as empresas. Por favor, feche e abra a modal novamente.',
            );

            return null;
        }
    }, [api]);

    const handleClean = useCallback(() => {
        onChange(null);
        onCancel();
    }, [onCancel, onChange]);

    const handleSave = useCallback(() => {
        onChange(selectedCompany);
        onCancel();
    }, [onCancel, onChange, selectedCompany]);

    const renderIsOpen = useCallback(isOpen => (isOpen ? 'Aberto' : 'Fechado'), []);

    const rowSelection = useMemo(() => ({
        type: 'radio',
        onChange: selectedKeys => {
            setSelectedCompany(Number(selectedKeys[0]));
        },
    }), []);

    const basicFilter = () => {
        return (
            <div>
                <Input.Field
                    allowClear
                    name="name"
                    autoFocus
                    label="Pesquisa"
                    placeholder="Busque por nome, endereço ou categoria"
                    width={340}
                />
            </div>
        );
    };

    return (
        <Modal
            {...others}
            footer={null}
            width="1200px"
            onCancel={onCancel}
        >
            <div className={styles.title}>Selecione a empresa</div>
            <SimpleListContent
                ref={$companiesListRef}
                basicFilter={basicFilter()}
                tableRowSelection={rowSelection}
                requestDataSource={requestDataSource}
            >
                <Column
                    dataIndex="name"
                    title="Nome"
                />
                <Column
                    dataIndex="internalAddress"
                    title="Endereço"
                />
                <Column
                    dataIndex="category"
                    title="Categoria"
                />
                <Column
                    dataIndex="isOpen"
                    title="Horário de serviço"
                    render={renderIsOpen}
                />
            </SimpleListContent>
            <div className={styles.actions}>
                <Button
                    type="primary"
                    backgroundColor="#FFF"
                    fontColor="#000"
                    className={styles.cleanButton}
                    onClick={handleClean}
                >
                    Limpar
                </Button>
                <Button
                    disabled={!selectedCompany}
                    onClick={handleSave}
                >
                    Salvar
                </Button>
            </div>
        </Modal>
    );
};

export default wrapDialog(CompaniesModal);
